import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField/index.js";
import Toolbar from "@mui/material/Toolbar/index.js";
import "react/jsx-runtime";
import "@mui/material";
import { FilterIcon } from "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(2)
}));
const ToolbarLeftSection = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2)
}));
const StyledFilterIcon = styled(FilterIcon)(({ theme }) => ({
  color: theme.palette.grey[700],
  marginTop: theme.spacing(0.5),
  "&:hover": {
    color: theme.palette.primary[800],
    cursor: "pointer"
  }
}));
const Switch = styled("div")(({ theme }) => ({
  display: "flex",
  border: `1px solid ${theme.palette.primary[800]}`,
  borderRadius: "8px",
  overflow: "hidden"
}));
const SwitchOption = styled("button", {
  shouldForwardProp: (prop) => prop !== "isSelected"
})(({ isSelected, theme }) => ({
  padding: theme.spacing(1, 2),
  backgroundColor: isSelected ? theme.palette.primary[800] : theme.palette.common.white,
  color: isSelected ? theme.palette.common.white : theme.palette.primary[800],
  transition: "background-color 0.3s ease, color 0.3s ease",
  fontFamily: "Lato",
  fontWeight: "700",
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  cursor: "pointer",
  border: "none",
  "&:hover": {
    backgroundColor: isSelected ? theme.palette.primary[800] : theme.palette.primary[50]
  },
  "&:first-of-type": {
    borderRight: `1px solid ${theme.palette.primary[800]}`
  }
}));
const SearchField = styled(TextField)(({ theme }) => ({
  width: "309px",
  fontFamily: "Lato",
  fontWeight: "400",
  fontSize: "12px",
  lineHeight: "16px",
  letterSpacing: "0.4px",
  color: theme.palette.grey[800],
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px"
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${theme.palette.grey[300]}`,
    "&:hover": {
      border: `1px solid ${theme.palette.grey[700]}`
    }
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: `2px solid ${theme.palette.primary[800]}`
  },
  "& svg": {
    color: theme.palette.grey[700]
  }
}));
export {
  SearchField,
  StyledFilterIcon,
  StyledToolbar,
  Switch,
  SwitchOption,
  ToolbarLeftSection
};
